import type { PoiCategory, TreeCondition } from '@api/types'

// Colores para lo que no puede usar clases de Tailwind (las capas del mapa son WebGL).
// DEBEN coincidir con los tokens de styles.css (@theme): lo comprueba colors.test.ts.
export const CONDITION_HEX: Record<TreeCondition | 'none', string> = {
	healthy: '#15803d',
	dry: '#b45309',
	needs_pruning: '#c2410c',
	damaged: '#dc2626',
	none: '#78716c', // earth-600: árbol sin avisos todavía
}

export const POI_HEX: Record<PoiCategory, string> = {
	heritage: '#1d4ed8', // poi
	singular_space: '#1f6f8b',
	magic_place: '#7a3e9d',
}

export const TRACK_HEX = '#b45309' // ochre

export const ROUTE_HEX = '#314524' // olive-900: la etapa elegida, continua, como una ruta a seguir
